module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-day",
    class: _vm.classesDay,
    on: {
      "mouseenter": _vm.mouseEnterDay,
      "mouseleave": _vm.mouseLeaveDay,
      "mousemove": function($event) {
        $event.stopPropagation();
        return _vm.mouseMoveDay($event)
      },
      "mousedown": _vm.mouseDownDay,
      "mouseup": _vm.mouseUpDay,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ds-week-weekday"
  }, [_vm._v("\n    " + _vm._s(_vm.weekday) + "\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "ds-week-date",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.viewDay($event)
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.dayOfMonth) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-all-events"
  }, [_vm._l((_vm.visibleEvents), function(event, i) {
    return [_c('ds-calendar-event', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "calendar-event": event,
        "index": i,
        "calendar": _vm.calendar
      }
    }, 'ds-calendar-event', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  }), _vm._v(" "), (_vm.hasPlaceholder) ? _c('div', [_c('ds-calendar-event-placeholder', _vm._g(_vm._b({
    attrs: {
      "day": _vm.day,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "calendar": _vm.calendar,
      "index": _vm.visibleEvents.length
    }
  }, 'ds-calendar-event-placeholder', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-238290c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeekDayHeader.vue
// module id = 159
// module chunks = 0